import { useState } from 'react';

const useCustomPrintConfig = ({ albumCustomPrint, initialConfiguration }) => {
  const positions = Array.from({ length: albumCustomPrint.photos_no });
  const initialConfig = {
    selectedPhotoPosition: null,
    editingPhoto: false,
    custom_print_caption: initialConfiguration?.custom_print_caption,
    photos: positions.map((_, index) => {
      const existingPhoto = initialConfiguration?.photos?.find(
        photo => photo.position === index,
      );
      if (existingPhoto) {
        return existingPhoto;
      }

      return {
        position: index,
        photo: null,
        asset_image: null,
        cropbox: {
          x: 0,
          y: 0,
          scale: 1,
          rotation: 0,
        },
      };
    }),
  };

  const [config, setConfig] = useState(initialConfig);

  const onPhotoEdit = (input, position) => {
    setConfig(prevConfig => ({
      ...prevConfig,
      selectedPhotoPosition: null,
      editingPhoto: false,
      photos: prevConfig.photos.map(photo => {
        if (photo.position === position) {
          return {
            ...photo,
            ...input,
          };
        }

        return photo;
      }),
    }));
  };

  const onPhotoSelect = (photo, position) => {
    setConfig(prevConfig => ({
      ...prevConfig,
      editingPhoto: true,
      photos: prevConfig.photos.map(p => {
        if (p.position === position) {
          return {
            ...p,
            photo,
          };
        }

        return p;
      }),
    }));
  };

  const onCaptionEdit = input => {
    setConfig(prevConfig => ({
      ...prevConfig,
      custom_print_caption: input,
    }));
  };

  const onPhotoSelectCancel = () => {
    setConfig(prevConfig => ({
      ...prevConfig,
      selectedPhotoPosition: null,
    }));
  };

  const onPhotoSelectTrigger = position => {
    setConfig(prevConfig => ({
      ...prevConfig,
      selectedPhotoPosition: position,
    }));
  };

  const setPhotoEditing = value => {
    setConfig(prevConfig => ({
      ...prevConfig,
      editingPhoto: value,
    }));
  };

  const selectedPhoto = config.photos.find(
    ({ position }) => position === config.selectedPhotoPosition,
  );

  return {
    config,
    onPhotoEdit,
    onCaptionEdit,
    onPhotoSelect,
    onPhotoSelectCancel,
    onPhotoSelectTrigger,
    selectedPhoto,
    setPhotoEditing,
  };
};

export default useCustomPrintConfig;
